module.exports = __webpack_public_path__ + "static/media/Electivire_gaussian2.cd792624.png";